module.exports = __webpack_public_path__ + "img/enableExtendConfirmSetting_02.675aaef5.png";